import axios from 'axios'
import store from "@/store";
import router from '@/router/index'

export default {
    state: {
        userCourseDetail: [],
        userCourseJoin: [],
        trainerCourseCreate: [],
        trainerCourseView: [],
        trainerCourseUpdate: [],
        trainerCourseDelete: [],
        trainerCourseSessionUpdate: []
    },

    getters: {
        trainerCourseSessionUpdate(state) {
            return state.trainerCourseSessionUpdate
        },
        trainerCourseCreate(state) {
            return state.trainerCourseCreate
        },
        userCourseDetail(state) {
            return state.userCourseDetail
        },
        userCourseJoin(state) {
            return state.userCourseJoin
        },
        trainerCourseView(state) {
            return state.trainerCourseView
        },
        trainerCourseUpdate(state) {
            return state.trainerCourseUpdate
        },
        trainerCourseDelete(state) {
            return state.trainerCourseDelete
        }
    },

    actions: {
        async TrainerCourseCreate({ commit }, payload) {
            store.commit("setIsLoading", true);
            try {
                const res = await axios.post('trainer/course/create', payload.data)
                store.commit("setIsSuccess", res && res.data && res.data.message);
                payload && payload.action && payload.action === 'exit' ? commit('setTrainerCourseCreateExit', res && res.data && res.data.data) : commit('setTrainerCourseCreate', res && res.data && res.data.data)
                store.commit("setIsLoading", false);
            } catch (e) {
                console.log(e)
                store.commit("setIsLoading", false);
                const error = {
                    title: "Error occured",
                    text:
                    e.response &&
                    e.response.data &&
                    e.response.data.data &&
                    e.response.data.data.message
                };
                store.commit("setError", error);
            }
        },

        async getTrainerCourseView({ commit }, { id, query }) {
            let res = null;
            if (query) {
                res = await axios.get(`trainer/course/view/${id}`, { params: query });
            }
            else {
                res = await axios.get(`trainer/course/view/${id}`)

            }
            const data = res && res.data && res.data.data
            commit('setTrainerCourseView', data)
        },

        async trainerCourseUpdate({ commit }, data) {
            store.commit("setIsLoading", true);
            let id = ''
            for (var pair of data.entries()) {
                if (pair[0] == 'id') {
                    id = pair[1]
                }
            }
            try {
              const res = await axios.post(`trainer/course/update/${id}`, data)
              store.commit("setIsSuccess", res && res.data && res.data.message);
              const newData = res && res.data && res.data.data
              commit('setTrainerCourseUpdate', newData)
              store.commit("setIsLoading", false);
            } catch(err) {
              store.commit('setIsLoading', false)
              store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
              throw err;
            }
            
        },

        async trainerCourseSessionUpdate({ commit }, data) {
            let id = ''
            for (var pair of data.entries()) {
                if (pair[0] == 'id') {
                    id = pair[1]
                }
            }
            const res = await axios.post(`trainer/course/session/update/${id}`, data)

            store.commit("setIsSuccess", res && res.data && res.data.message);

            const newData = res && res.data && res.data.data
            commit('setTrainerCourseSessionUpdate', newData)
        },

        async getTrainerCourseDelete({ commit }, id) {
            const res = await axios.post(`trainer/course/delete/${id}`)

            store.commit("setIsSuccess", res && res.data && res.data.message);

            const data = res && res.data && res.data.data
            commit('setTrainerCourseDelete', data)
        },

        async getUserCourseDetail({ commit }, id) {
            const res = await axios.get(`user/course/detail/${id}`)

            const data = res && res.data && res.data.data
            commit('setUserCourseDetail', data)
        },

        async getUserCourseDetailMore({ commit }, id) {
            const res = await axios.get(`user/course/detail/${id}`)

            const data = res && res.data && res.data.data
            commit('setUserCourseDetailMore', data)
        },

        async getUserCourseDetailLess({ commit }, id) {
            const res = await axios.get(`user/course/detail/${id}`)

            const data = res && res.data && res.data.data
            commit('setUserCourseDetailLess', data)
        },

        async userCourseJoin({ commit }, data) {
            const res = await axios.post(`user/course/join`, data)

            store.commit("setIsSuccess", res && res.data && res.data.message);

            const newData = res && res.data && res.data.data
            commit('setUserCourseJoin', newData)
        }
    },

    mutations: {
        setUserCourseJoin(state, data) {
            // state.userCourseJoin = data
            location.reload()
        },

        setUserCourseDetail(state, data) {
            state.userCourseDetail = data
        },

        setUserCourseDetailMore(state, data) {
            // state.userCourseDetail = data
            state.userCourseDetail.course_groups.available.next_page_url = data.course_groups.available.next_page_url
            data.course_groups.available.data.map(d => {
                state.userCourseDetail.course_groups.available.data.push(d)
            })
        },

        setUserCourseDetailLess(state, data) {
            // state.userSessionDetail = data
            state.userCourseDetail.course_groups.available.next_page_url = data.course_groups.available.next_page_url
            state.userCourseDetail.course_groups.available.data = state.userCourseDetail.course_groups.available.data.slice(0, 3);
        },

        setTrainerCourseCreate(state, data) {
            state.trainerCourseCreate = data
            // router.push({ name: "course", params: { id: data.id } });
            router.push({
                name: "TrainerCalendar", query: {
                    id: data && data.id,
                    title: data && data.title,
                    type: data && data.entity_type,
                    url: data && data.thumbnail_url,
                    sessions: data && data.sessions,
                },
            });
        },
        setTrainerCourseCreateExit(state, data) {
            state.trainerCourseCreate = data
            router.push({ name: "course", params: { id: data.id } });
        },

        setTrainerCourseView(state, data) {
            state.trainerCourseView = data
        },

        setTrainerCourseUpdate(state, data) {
            state.trainerCourseUpdate = data
        },

        setTrainerCourseSessionUpdate(state, data) {
            state.trainerCourseSessionUpdate = data
        },

        setTrainerCourseDelete(state, data) {
            state.trainerCourseDelete = data
        }
    }
}